import React from 'react';
import { MdOutlineShoppingCart, MdAdd } from 'react-icons/md';

import { Button, ButtonProps } from '@rsc/ui-components/shadcn/Button';

const SimpleCartBtn = (props: Readonly<ButtonProps>) => {
  const iconClasses = 'w-6 h-6 fill-cta-foreground';

  return (
    <Button className="gap-0 h-10 group" size="sm" variant="cta" {...props}>
      <MdOutlineShoppingCart className={iconClasses} />
      <MdAdd className={iconClasses} />
    </Button>
  );
};

export default SimpleCartBtn;
